module.exports = __webpack_public_path__ + "img/work_completed.454608ee.png";